import type { CatalogEntry } from '../types/catalog';
import type { DriveProfile } from '../types/drive';

export function createProfileFromCatalog(entry: CatalogEntry): DriveProfile {
  const id = entry.modelCode.replace(/[^a-zA-Z0-9_-]/g, '_');
  return {
    id,
    name: entry.name,
    vendor: entry.vendor,
    powerKW: entry.powerKW,
    voltageClass: entry.voltageClass,
    ratedFrequency: entry.ratedFrequency,
    coolingMethod: entry.coolingMethod,
    protectionRating: entry.protectionRating,
    fanCount: entry.fanCount,
    family: entry.family,
    modelCode: entry.modelCode,
    nominalCurrent: entry.nominalCurrent,
    nominalCurrentND: entry.nominalCurrentND,
    nominalCurrentHD: entry.nominalCurrentHD,
    nominalDC: entry.nominalDC,
    maxTemp: entry.maxTemp,
    currentScale: entry.modbusMap.currentScale,
    regFreq: entry.modbusMap.regFreq,
    regCurrent: entry.modbusMap.regCurrent,
    regDC: entry.modbusMap.regDC,
    regTemp: entry.modbusMap.regTemp,
    regWriteFreq: entry.modbusMap.regWriteFreq,
    poles: entry.modbusMap.poles,
    rulParams: { ...entry.rulParams },
    tripCodes: { ...entry.tripCodes },
    partNumber: entry.partNumber,
    orderingNumber: entry.orderingNumber,
    frameSize: entry.frameSize,
    powerCardCode: entry.powerCardCode,
    igbtModuleCode: entry.igbtModuleCode,
    fanCode: entry.fanCode,
    capacitorBankCode: entry.capacitorBankCode,
  };
}